import { generateApiPath } from "@routes/generatePath";

const pathBase = `/reports/no-show-appointments/`;

export const noShowAppointment = {
  get: () => generateApiPath(pathBase),
};
